import { LoginLayout, SamlLoginForm } from "features/login";
import { useCheckLoginStatus } from "Hooks";

export const SamlLogin = () => {
  useCheckLoginStatus();
  return <LoginLayout form={<SamlLoginForm />} />;
};
